import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { ICargaArchivo, IListaArchivos } from 'src/app/interfaces/ponderaciones';
import { ArchivoEjemplo, IListaPeriodos } from 'src/app/interfaces/utils';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-view-ponderacion-masiva',
  templateUrl: './view-ponderacion-masiva.component.html',
  styleUrls: ['./view-ponderacion-masiva.component.scss']
})
export class ViewPonderacionMasivaComponent  implements OnInit{
  dtOptions: DataTables.Settings = {};
  mostrarDescargaInfo: boolean = false
  listaArchivos!: IListaArchivos;
  listaAnyos: number[] = [];
  renderTableListaArchivos: boolean = false
  archivoEjemplo : ArchivoEjemplo = new ArchivoEjemplo();
  nombreEjemplo: string = "ejemplo_carga_ponderaciones_masivas.xlsx"
  filesAttached: any = []
  archivoBase64: any = ''
  allowedFilesExt = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ]
  cabeceraBase64 = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
  allowedFileSizeBytes = 10485760
  textoCargaArchivo = "Seleccionar archivo...";
  error = "";
  mensajeExito = "";
  mensajeDescargaExito = "";
  errorDescarga = "";
  errorCopia = "";
  mensajeExitoCopiar = "";
  funcionIntervalo: any;
  procesandoPonderacion: boolean = false;
  anyoSeleccionado: any = {
    carga: 0,
    descarga: 0,
    copiarOrigen: 0,
    copiarDestino: 0
  };
  periodoSeleccionado: any = {
    carga: 0,
    descarga: 0,
    copiarOrigen: 0,
    copiarDestino: 0
  };
  listaPeriodos: any = {
    carga: [],
    descarga: [],
    copiarOrigen: [],
    copiarDestino: []
  };
  nombreUsuario: string = "";
  tieneErrores: any = {}
  submitted: boolean = false;



  constructor (
    private formBuilder: FormBuilder,
    private ponderacionesService: PonderacionesService,
    private spinner: NgxSpinnerService,
    private utilsService: UtilsService,
    private perfilamientoService:PerfilamientoService
  ) {
  }
  getListaAnyos() {
    this.utilsService.obtenerListaAnhos().subscribe(
      (res: any) => {
        if (res.error != null) {
          this.error = res.error;
          this.limpiarMensajes();
        } else {
          this.listaAnyos = res.anyos;
        }
      }
    )
  }
  getListaIntervalo() {
    this.procesandoPonderacion = false;
    this.renderTableListaArchivos = false;
    this.ponderacionesService.getListaArchivosPonderacionMasiva().subscribe(
      (res: IListaArchivos) => {
        this.listaArchivos = res;
        this.procesandoPonderacion = this.listaArchivos.isProcesando;
        this.renderTableListaArchivos = true;
      }
    )
  }
  getListaArchivos() {
    this.ponderacionesService.getListaArchivosPonderacionMasiva().subscribe(
      (res: IListaArchivos) => {
        this.listaArchivos = res;
        this.procesandoPonderacion = this.listaArchivos.isProcesando;
        this.renderTableListaArchivos = true;
      }, err => {
      }
    )
  }

  ngOnInit(): void {
    let datosUsuario = this.perfilamientoService.getUsuario();
    this.nombreUsuario =datosUsuario.username;

    this.dtOptions = { ...DatatableConfig.dtOptionDefaultSearchLeft };
    this.dtOptions.order = [[0,"desc"]];
    this.getListaAnyos();
    this.getListaArchivos();
    this.funcionIntervalo = setInterval(() =>{
      if (this.procesandoPonderacion) {
        this.getListaIntervalo();
      }

    }, 30000);
  }
  ngOnDestroy(): void {
    clearInterval(this.funcionIntervalo);

  }

  toggleDescargaInfo() {
    this.mostrarDescargaInfo = !this.mostrarDescargaInfo
  }

  limpiarMensajes() {
    setTimeout(() => {
      this.error = ''
      this.errorDescarga = "";
      this.mensajeDescargaExito = "";
      this.mensajeExito = "";
      this.mensajeExitoCopiar = "";
      this.errorCopia = "";
    }, 15000);
  }
  descargarEjemplo(): void {
    const bstr = atob(this.archivoEjemplo.archivo);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], this.nombreEjemplo, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    let link = document.createElement('a');

    //Adicionar y descargar el archivo
    link.href = window.URL.createObjectURL(file);
    link.download = this.nombreEjemplo;
    link.click();
    this.mensajeExito = "El archivo se ha generado con éxito.";

    this.limpiarMensajes();
  }
  onFileChanged(event: any, index: number, discountFile: boolean = false) {
    const file:File = event.target.files[0];
    if ( file ) {
      if ( this.filesAttached[index] ) this.filesAttached[index] = null

      if ( ((file.size)) > this.allowedFileSizeBytes ) {
        this.error = 'El tamaño del archivo es mayor a 10Mb.'
        this.limpiarMensajes()
        return
      }
      if ( !this.allowedFilesExt.includes(file.type) ) {
        this.error = 'Tipo de archivo no válido. El tipo de archivo debe ser xlsx'
        this.limpiarMensajes()
        return
      }
      this.filesAttached[index] = {};
      this.filesAttached[index].archivo = file;
      this.filesAttached[index].nombreArchivo = file.name;
      this.filesAttached[index].tipoArchivo = file.type;

      let reader = new FileReader();
      reader.onload =this._handleReaderLoaded.bind(event);
      reader.readAsBinaryString(file);
      this.textoCargaArchivo = file.name;

      event.target.value = "";
    }
  }

  _handleReaderLoaded(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.archivoBase64 = btoa(binaryString);
  }

  fnTieneErrores(): boolean {
    let tieneErrores = false;
    if(this.periodoSeleccionado.carga == 0) {
      tieneErrores = true;
      this.tieneErrores["periodoCarga"] = true;
    }
    if(this.anyoSeleccionado.carga == 0) {
      tieneErrores = true;
      this.tieneErrores["anyoCarga"] = true;
    }
    if(this.filesAttached.length == 0){
      tieneErrores = true;
      this.tieneErrores["archivoCarga"] = true;
    }
    return tieneErrores
  }

  fnManejoErrorCargaArchivo(error: any) {
    if(error.error.details[0].split(" ")[0] == "No") {
      let codigoPeriodo = 0;
        this.listaPeriodos.carga.forEach((periodo: any) => {
          if (periodo.periodoAcademicoId == this.periodoSeleccionado.carga) {
            codigoPeriodo = periodo.codigoPeriodo;
          }
        });
      this.error = error?.error?.details?.[0] ?? "No existe una configuración de ponderaciones con la fecha actual y el año " + this.anyoSeleccionado.carga + " y periodo " + codigoPeriodo;
    }
    this.limpiarMensajes();
  }

  cargarArchivo() {
    let tieneErrores = this.fnTieneErrores();
    this.submitted = true;
    
    if (!tieneErrores) {
      let reader = new FileReader();
      reader.onload = (readerEvt: any) => {
        let binaryString = readerEvt.target.result;
        this.archivoBase64 = binaryString.split("base64,")[1];

        const serviceData: ICargaArchivo = {
          anyo: this.anyoSeleccionado.carga,
          periodoAcademicoId: this.periodoSeleccionado.carga,
          archivo: this.archivoBase64,
          extension: "xlsx",
          nombreArchivo: this.filesAttached[0].nombreArchivo,
          usuarioCreacion: this.nombreUsuario
        }
        this.ponderacionesService.cargarArchivoPonderacionMasiva(serviceData).subscribe({
          next: (res: any) => {
            if (res.details != null) {
              this.error = res.details.
              this.limpiarMensajes();
            } else {
              this.getListaIntervalo();
              this.mensajeExito = "La solicitud de carga de ponderación masiva ha sido recibida correctamente."
              this.limpiarMensajes();
            }
          },
          error: error => {
            this.fnManejoErrorCargaArchivo(error)
          }
        })
      };
      reader.readAsDataURL(this.filesAttached[0].archivo)
    }
  }
  limpiarCargaArchivo(): void {
    this.textoCargaArchivo = "Seleccionar archivo...";
    this.filesAttached = [];
    this.anyoSeleccionado.carga = 0;
    this.periodoSeleccionado.carga = 0;
  }

  descargarLogs(index: number): void {
    let ponderacionId = this.listaArchivos.archivos[index].archivoPonderacionId;
    this.ponderacionesService.descargarLogPonderacionMasiva(ponderacionId).subscribe(
      (res: any) => {
        if(res.error != null){
          this.error = res.error.mensaje;
          this.limpiarMensajes();
        } else {
          const bstr = atob(res.archivo);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          const file = new File([u8arr], res.nombreArchivo, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          let link = document.createElement('a');

          //Adicionar y descargar el archivo
          link.href = window.URL.createObjectURL(file);
          link.download = res.nombreArchivo;
          link.click();
          this.mensajeExito = "El archivo se ha generado con éxito.";

          this.limpiarMensajes();
        }
      }
    )
  }
  resetearValidacion() {
    this.submitted = false;
    this.tieneErrores["anyoOrigen"] = false;
    this.tieneErrores["periodoOrigen"] = false;
    this.tieneErrores["anyoDestino"] = false;
    this.tieneErrores["periodoDestino"] = false;
    this.tieneErrores["anyoDescarga"] = false;
    this.tieneErrores["periodoDescarga"] = false;
    this.tieneErrores["anyoCarga"] = false;
    this.tieneErrores["periodoCarga"] = false;
    this.tieneErrores["archivoCarga"] = false;
  }
  validarCopia(): void {
    let tieneErrores = false;
    this.submitted = true;
    if(this.periodoSeleccionado.copiarOrigen == 0) {
      tieneErrores = true;
      this.tieneErrores["periodoOrigen"] = true;
    }
    if(this.anyoSeleccionado.copiarOrigen == 0) {
      tieneErrores = true;
      this.tieneErrores["anyoOrigen"] = true;
    }
    if(this.periodoSeleccionado.copiarDestino == 0) {
      tieneErrores = true;
      this.tieneErrores["periodoDestino"] = true;
    }
    if(this.anyoSeleccionado.copiarDestino == 0) {
      tieneErrores = true;
      this.tieneErrores["anyoDestino"] = true;
    }
    if(!tieneErrores) {
      this.copiarPonderacion();
    }
  }

  fnErrorCopia(res: any, codigoPeriodo: any): any {
    let inicioError = res.error.mensaje.split(" ");
    if(inicioError[0] == "No") {
      this.errorCopia = "No existe una configuración de ponderaciones con la fecha actual y el año " + this.anyoSeleccionado.copiarDestino + " y periodo " + codigoPeriodo;
    }
    else if (inicioError[0] == "Existen") {
      this.errorCopia = "Existen datos para el año " + this.anyoSeleccionado.copiarDestino + " y periodo " + codigoPeriodo;
    } else {
      this.errorCopia = res.error.mensaje;
    }
  }

  copiarPonderacion(): void {
    let tieneErrores = false;
    if (this.anyoSeleccionado.copiarDestino == this.anyoSeleccionado.copiarOrigen && this.periodoSeleccionado.copiarOrigen == this.periodoSeleccionado.copiarDestino) {
      this.errorCopia = "No ha sido posible realizar la copia, ajuste la información solicitada he intente nuevamente.";
      tieneErrores = true;
      this.limpiarMensajes();
    }

    if(!tieneErrores){
      let body = {
        anyoOrigen: this.anyoSeleccionado.copiarOrigen,
        anyoDestino: this.anyoSeleccionado.copiarDestino,
        periodoIdOrigen: this.periodoSeleccionado.copiarOrigen,
        periodoIdDestino: this.periodoSeleccionado.copiarDestino
      }
      this.ponderacionesService.copiarPonderacionMasiva(body).subscribe({
        next: (res: IListaPeriodos) => {
          if (res.error != null) {
            let codigoPeriodo = 0;
            this.listaPeriodos.copiarDestino.forEach((periodo: any) => {
              if (periodo.periodoAcademicoId == this.periodoSeleccionado.copiarDestino) {
                codigoPeriodo = periodo.codigoPeriodo;
              }
            });
            this.fnErrorCopia(res, codigoPeriodo)
          }else {
            this.mensajeExito = "Se ha realizado la copia correctamente.";
            $("#btn-copiar").trigger("click");
          }
          this.limpiarMensajes();
          this.limpiarSelects();

        },
        error: error => {
          this.limpiarMensajes();
          this.limpiarSelects();
        }
      })
    }
  }

  fnTieneErroresPonderacion(): boolean {
    let tieneErrores = false;
    if(this.periodoSeleccionado.descarga == 0) {
      tieneErrores = true;
      this.tieneErrores["periodoDescarga"] = true;
    }
    if(this.anyoSeleccionado.descarga == 0) {
      tieneErrores = true;
      this.tieneErrores["anyoDescarga"] = true;
    }
    return tieneErrores
  }

  descargarPonderacion(): void {
    let tieneErrores = this.fnTieneErroresPonderacion();
    this.submitted = true;
    
    if (!tieneErrores) {
      let body = {
        anyo: this.anyoSeleccionado.descarga,
        periodoId: this.periodoSeleccionado.descarga
      };
      this.ponderacionesService.descargarPonderacion(body).subscribe({
        next:(res: any) => {
          if (res.error != null) {
            let codigoPeriodo = 0;
            this.listaPeriodos.descarga.forEach((periodo: any) => {
              if (periodo.periodoAcademicoId == this.periodoSeleccionado.descarga) {
                codigoPeriodo = periodo.codigoPeriodo;
              }
            });
            this.errorDescarga = "No existen datos para el año " + this.anyoSeleccionado.descarga + " y periodo " + codigoPeriodo;
            this.limpiarMensajes();
          }else {
            const bstr = atob(res.archivo);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            const file = new File([u8arr], "carga_masiva_ponderacion", {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            let link = document.createElement('a');

            //Adicionar y descargar el archivo
            link.href = window.URL.createObjectURL(file);
            link.download = "carga_masiva_ponderacion";
            link.click();
            this.mensajeDescargaExito = "El archivo se ha generado con éxito.";
            this.limpiarMensajes();
          }
        },
        error: error => {
        }

      })
    }
  }
  obtenerListaPeriodos(año: number,selectSolicitante: string): void {
    if(this.anyoSeleccionado.carga == 0 && selectSolicitante == "carga") {
      return;
    }else {
      this.periodoSeleccionado[selectSolicitante] = 0;
      this.utilsService.obtenerListaPeriodos(año).subscribe({
        next: (res: IListaPeriodos) => {
          this.listaPeriodos[selectSolicitante] = res.periodos;
        },
        error: error => {
          // this.error = "Ha ocurrido un error."
          this.limpiarMensajes();
        }
      })
    }
  }
  limpiarSelects(): void {
    this.anyoSeleccionado.copiarOrigen = 0;
    this.anyoSeleccionado.copiarDestino = 0;
    this.periodoSeleccionado.copiarOrigen = 0;
    this.periodoSeleccionado.copiarDestino = 0;
  }
}

